const smoothScrollTo = (to, duration, scrollingElement, horizontal = false) => {
	const element = scrollingElement || document.scrollingElement || document.documentElement;
	const start = horizontal ? element.scrollLeft : element.scrollTop;
	const change = to - start;
	const startDate = +new Date();
	// t = current time
	// b = start value
	// c = change in value
	// d = duration
	const easeInOutQuad = (t, b, c, d) => {
		t /= d / 2;
		if (t < 1) {
			return c / 2 * t * t + b;
		}
		t--;
		return -c / 2 * (t * (t - 2) - 1) + b;
	};
	const animateScroll = () => {
		const currentDate = +new Date();
		const currentTime = currentDate - startDate;
		horizontal ?
			element.scrollLeft = parseInt(easeInOutQuad(currentTime, start, change, duration))
			: element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
		if (currentTime < duration) {
			requestAnimationFrame(animateScroll);
		} else {
			horizontal ? element.scrollLeft = to : element.scrollTop = to;
		}
	};
	animateScroll();
};

export default smoothScrollTo;